import { createAEGTheme } from '@aeg-presents/shared-components/AEGTheme';
import { AuthProvider as DescopeProvider } from '@descope/react-sdk';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { ApolloClientProvider } from './providers/ApolloProvider/ApolloClientProvider';
import { AuthProvider } from './providers/AuthProvider/AuthProvider';
import { AppRoutes } from './routes/AppRoutes';
import type { EnvConfig } from './types/EnvConfig';

const appTheme = createAEGTheme();

interface AppProps {
  envConfig: EnvConfig;
}

export function App({ envConfig }: AppProps) {
  return (
    <DescopeProvider projectId={envConfig.DESCOPE_PROJECT_ID}>
      <ApolloClientProvider
        connectToDevTools={envConfig.ENABLE_APOLLO_DEV_TOOLS}
        endpoint={envConfig.EXTERNAL_AGG_ENDPOINT}
      >
        <AuthProvider>
          <ThemeProvider theme={appTheme}>
            <CssBaseline />
            <AppRoutes />
          </ThemeProvider>
        </AuthProvider>
      </ApolloClientProvider>
    </DescopeProvider>
  );
}
